<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'PageIndex',
  created () {
    // 兼容旧的hash模式
    const hash = this.$route.hash
    if (hash) {
      let path = hash.substring(1)
      if (path) {
        let matched = this.$router.getMatchedComponents(path)
        if (matched && matched.length) {
          this.$router.replace(path)
        }
      }
    }
  }
}
</script>
